import cookie from '../cookie';

export const getCookieConsent = () => JSON.parse(cookie.get('cc_cookie') || null);

export const hasCookieConsent = () => !!getCookieConsent();

export const hasCookieConsentCategory = (category) => {
  const consent = getCookieConsent();
  return (consent?.categories || []).includes(category);
};
